import { render, staticRenderFns } from "./FormAccessRequestDatasource.vue?vue&type=template&id=46fd243f&lang=pug"
import script from "./FormAccessRequestDatasource.vue?vue&type=script&lang=js"
export * from "./FormAccessRequestDatasource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46fd243f')) {
      api.createRecord('46fd243f', component.options)
    } else {
      api.reload('46fd243f', component.options)
    }
    module.hot.accept("./FormAccessRequestDatasource.vue?vue&type=template&id=46fd243f&lang=pug", function () {
      api.rerender('46fd243f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/FormAccessRequestDatasource.vue"
export default component.exports